import { render, staticRenderFns } from "./SizeOptionDialogue.vue?vue&type=template&id=3fd8c479&"
import script from "./SizeOptionDialogue.vue?vue&type=script&lang=ts&"
export * from "./SizeOptionDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports